import axios from "axios";
import exportedUrls from "../../utils/constants/urls";
import {
  RESET_TOUR_STATE,
  UPDATE_PRODUCT_TOUR,
  COMPLETE_RESET_TOUR_STATE,
} from "../types";

export const updateProductTour = (key, payload) => (dispatch) => {
  dispatch({
    type: UPDATE_PRODUCT_TOUR,
    key,
    payload,
  });
};

export const resetProductTour = () => (dispatch) => {
  dispatch({
    type: RESET_TOUR_STATE,
  });
};

export const completelyResetTourState = () => (dispatch) => {
  dispatch({
    type: COMPLETE_RESET_TOUR_STATE,
  });
};

export const getCmsContent = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${exportedUrls.strapiCMS}/product-updates`)
      .then((res) => {
        dispatch(updateProductTour("cmsProductUpdates", res?.data));
        return resolve(res?.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
